// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.time-range-picker {
  background: rgb(var(--white));
  box-shadow: 0 1px 12px rgba(0, 0, 0, 0.3);
  border-radius: var(--border-radius);
  -webkit-user-select: none;
          user-select: none;
  min-width: 310px;
}
.time-range-picker .time-range-picker__header {
  border-bottom: 1px solid rgb(var(--gray-color-10));
}
.time-range-picker .time-range-picker__header ::ng-deep lg-dropdown {
  height: 36px;
  display: block;
  width: calc(100% - var(--spacing2) - var(--spacing2));
  margin: 0;
  font-weight: 700;
  padding: 0 var(--spacing2);
}
.time-range-picker .time-range-picker__header ::ng-deep lg-dropdown .lg-dropdown {
  border: none;
}
.time-range-picker .time-range-picker__header ::ng-deep lg-dropdown .lg-dropdown:focus {
  box-shadow: none;
  border: none;
}
.time-range-picker .time-range-picker__header ::ng-deep lg-dropdown .lg-dropdown .lg-dropdown__text--empty {
  color: var(--gray-color-80);
}
.time-range-picker .time-range-picker__body {
  padding: var(--spacing3) var(--spacing4);
}
.time-range-picker .time-range-picker__body.first {
  border-bottom: 1px dashed rgb(var(--gray-color-10));
}
.time-range-picker .time-range-picker__footer {
  display: flex;
  justify-content: flex-end;
  padding: var(--spacing2);
  line-height: var(--spacing4);
  border-top: 1px solid rgb(var(--gray-color-10));
}
.time-range-picker .time-range-picker__footer lg-button:not(:last-child) {
  padding-right: var(--spacing2);
}

.month-list {
  margin-top: var(--spacing0);
  margin-bottom: 0;
  padding: 0;
  list-style: none;
}

.month-list__item {
  margin: 2px 0;
  display: inline;
  line-height: 32px;
}
.month-list__item:nth-child(6n)::after {
  content: "\\a";
  white-space: pre;
}

.month-list__dropdown {
  width: 70px;
}
.month-list__dropdown ::ng-deep .lg-dropdown .lg-dropdown__text {
  overflow: visible;
}

.month-list__dropdown,
.month-list__arrow-button {
  display: inline-block;
  vertical-align: middle;
  margin-right: var(--spacing0);
  height: var(--spacing5);
}

.month-list__button {
  background: none;
  border: none;
  font-size: rgb(var(--text-size-base));
  padding: 6px var(--spacing1);
  color: rgb(var(--gray-color-60));
  min-width: 45px;
  cursor: pointer;
}
.month-list__button--selected, .month-list__button--selected-first, .month-list__button--selected-last {
  background: rgb(var(--base-20));
  color: rgb(var(--base-60));
}
.month-list__button--selected-first {
  border-top-left-radius: var(--border-radius);
  border-bottom-left-radius: var(--border-radius);
}
.month-list__button--selected-last {
  border-top-right-radius: var(--border-radius);
  border-bottom-right-radius: var(--border-radius);
}

.month-list__item:hover .month-list__button {
  background-color: rgb(var(--base-05));
  color: rgb(var(--gray-color-80));
}
.month-list__item:hover .month-list__button--selected, .month-list__item:hover .month-list__button--selected-first, .month-list__item:hover .month-list__button--selected-last {
  background: rgb(var(--base-20));
  color: rgb(var(--base-60));
}
.month-list__item--disabled .month-list__button {
  opacity: 0.3;
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./libs/shared/ui-time-range-filter/src/lib/time-range-picker/time-range-picker.component.scss"],"names":[],"mappings":"AAEA;EACI,6BAAA;EACA,yCAAA;EACA,mCAAA;EACA,yBAAA;UAAA,iBAAA;EACA,gBAAA;AADJ;AAGI;EACI,kDAAA;AADR;AAGQ;EACI,YAAA;EACA,cAAA;EACA,qDAAA;EACA,SAAA;EACA,gBAAA;EACA,0BAAA;AADZ;AAGY;EACI,YAAA;AADhB;AAGgB;EACI,gBAAA;EACA,YAAA;AADpB;AAIgB;EACI,2BAAA;AAFpB;AAQI;EACI,wCAAA;AANR;AAQQ;EACI,mDAAA;AANZ;AAUI;EACI,aAAA;EACA,yBAAA;EACA,wBAAA;EACA,4BAAA;EACA,+CAAA;AARR;AAUQ;EACI,8BAAA;AARZ;;AAaA;EACI,2BAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;AAVJ;;AAaA;EACI,aAAA;EACA,eAAA;EACA,iBAAA;AAVJ;AAYI;EACI,aAAA;EACA,gBAAA;AAVR;;AAcA;EACI,WAAA;AAXJ;AAaI;EACI,iBAAA;AAXR;;AAeA;;EAEI,qBAAA;EACA,sBAAA;EACA,6BAAA;EACA,uBAAA;AAZJ;;AAeA;EACI,gBAAA;EACA,YAAA;EACA,qCAAA;EACA,4BAAA;EACA,gCAAA;EACA,eAAA;EACA,eAAA;AAZJ;AAcI;EAGI,+BAAA;EACA,0BAAA;AAdR;AAiBI;EACI,4CAAA;EACA,+CAAA;AAfR;AAkBI;EACI,6CAAA;EACA,gDAAA;AAhBR;;AAsBQ;EACI,qCAAA;EACA,gCAAA;AAnBZ;AAqBY;EAGI,+BAAA;EACA,0BAAA;AArBhB;AA2BQ;EACI,YAAA;EACA,oBAAA;AAzBZ","sourcesContent":["@use \"definitions\" as *;\n\n.time-range-picker {\n    background: lg-color(--white);\n    box-shadow: 0 1px 12px rgba(0, 0, 0, 0.3);\n    border-radius: var(--border-radius);\n    user-select: none;\n    min-width: 310px;\n\n    .time-range-picker__header {\n        border-bottom: 1px solid lg-color(--gray-color-10);\n\n        ::ng-deep lg-dropdown {\n            height: 36px;\n            display: block;\n            width: calc(100% - var(--spacing2) - var(--spacing2));\n            margin: 0;\n            font-weight: 700;\n            padding: 0 var(--spacing2);\n\n            .lg-dropdown {\n                border: none;\n\n                &:focus {\n                    box-shadow: none;\n                    border: none;\n                }\n\n                .lg-dropdown__text--empty {\n                    color: var(--gray-color-80);\n                }\n            }\n        }\n    }\n\n    .time-range-picker__body {\n        padding: var(--spacing3) var(--spacing4);\n\n        &.first {\n            border-bottom: 1px dashed lg-color(--gray-color-10);\n        }\n    }\n\n    .time-range-picker__footer {\n        display: flex;\n        justify-content: flex-end;\n        padding: var(--spacing2);\n        line-height: var(--spacing4);\n        border-top: 1px solid lg-color(--gray-color-10);\n\n        lg-button:not(:last-child) {\n            padding-right: var(--spacing2);\n        }\n    }\n}\n\n.month-list {\n    margin-top: var(--spacing0);\n    margin-bottom: 0;\n    padding: 0;\n    list-style: none;\n}\n\n.month-list__item {\n    margin: 2px 0;\n    display: inline;\n    line-height: 32px;\n\n    &:nth-child(6n)::after {\n        content: \"\\A\";\n        white-space: pre;\n    }\n}\n\n.month-list__dropdown {\n    width: 70px;\n\n    ::ng-deep .lg-dropdown .lg-dropdown__text {\n        overflow: visible;\n    }\n}\n\n.month-list__dropdown,\n.month-list__arrow-button {\n    display: inline-block;\n    vertical-align: middle;\n    margin-right: var(--spacing0);\n    height: var(--spacing5);\n}\n\n.month-list__button {\n    background: none;\n    border: none;\n    font-size: lg-color(--text-size-base);\n    padding: 6px var(--spacing1);\n    color: lg-color(--gray-color-60);\n    min-width: 45px;\n    cursor: pointer;\n\n    &--selected,\n    &--selected-first,\n    &--selected-last {\n        background: lg-color(--base-20);\n        color: lg-color(--base-60);\n    }\n\n    &--selected-first {\n        border-top-left-radius: var(--border-radius);\n        border-bottom-left-radius: var(--border-radius);\n    }\n\n    &--selected-last {\n        border-top-right-radius: var(--border-radius);\n        border-bottom-right-radius: var(--border-radius);\n    }\n}\n\n.month-list__item {\n    &:hover {\n        .month-list__button {\n            background-color: lg-color(--base-05);\n            color: lg-color(--gray-color-80);\n\n            &--selected,\n            &--selected-first,\n            &--selected-last {\n                background: lg-color(--base-20);\n                color: lg-color(--base-60);\n            }\n        }\n    }\n\n    &--disabled {\n        .month-list__button {\n            opacity: 0.3;\n            pointer-events: none;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
